import TabbedViewContainer from './TabbedViewContainer'
export default TabbedViewContainer
